import { memo } from "react";
import { Box, Container, Typography, Grid2 } from "@mui/material";
import { FullPaddingWrapper } from "../../Components/FullPaddingWrapper/FullPaddingWrapper";

// Assets
import teamImage from "./Assets/message-from-team.webp";

const MessageFromTeam = memo(() => {
  return (
    <Container maxWidth="xl" disableGutters>
      <FullPaddingWrapper>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            borderRadius: { xs: "16px", md: "24px" },
            overflow: "hidden",
            minHeight: { xs: "auto", md: 600, lg: 700 },
            mb: { xs: 4, md: 6 },
          }}
        >
          {/* Left Content Section */}
          <Box
            sx={{
              flex: 1,
              backgroundColor: "#004B4C",
              p: {
                xs: "40px 24px",
                sm: "50px 40px",
                md: "60px 50px",
                lg: "80px 70px",
              },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: "#ffffff",
                fontWeight: 600,
                fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                lineHeight: 1.2,
                mb: { xs: 3, md: 4 },
              }}
            >
              Message from Team
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#ffffff",
                fontSize: { xs: "0.95rem", md: "1rem", lg: "1.1rem" },
                fontWeight: 300,
                lineHeight: 1.7,
                mb: 3,
                opacity: 0.95,
                maxWidth: 550,
              }}
            >
              At SimplerHome, we believe homeownership shouldn't be stressful —
              it should be empowering.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#ffffff",
                fontSize: { xs: "0.95rem", md: "1rem", lg: "1.1rem" },
                fontWeight: 300,
                lineHeight: 1.7,
                mb: 3,
                opacity: 0.95,
                maxWidth: 550,
              }}
            >
              We're a team of homeowners, technologists, and industry
              professionals who have all felt the frustration of managing
              repairs, finding documents, juggling contractors, and wondering if
              we're doing enough to protect our most valuable investment: our
              home.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#ffffff",
                fontSize: { xs: "0.95rem", md: "1rem", lg: "1.1rem" },
                fontWeight: 300,
                lineHeight: 1.7,
                mb: 3,
                opacity: 0.95,
                maxWidth: 550,
              }}
            >
              That's why we built SimplerHome — a smart, intuitive platform that
              takes the guesswork out of managing your property. Whether it's
              tracking maintenance, accessing important records, or just knowing
              what to do next, we're here to simplify the process, reduce
              stress, and help you fall in love with your home again.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#ffffff",
                fontSize: { xs: "0.95rem", md: "1rem", lg: "1.1rem" },
                fontWeight: 300,
                lineHeight: 1.7,
                mb: { xs: 4, md: 5 },
                opacity: 0.95,
                maxWidth: 550,
              }}
            >
              We're not a big faceless tech company. We're a passionate crew
              that's walked in your shoes — and we're on a mission to bring
              calm, clarity, and confidence to every homeowner. Because your
              home should work for you — not the other way around.
            </Typography>

            <Box>
              <Typography
                variant="h4"
                sx={{
                  color: "#ffffff",
                  fontWeight: 600,
                  fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2rem" },
                  lineHeight: 1.3,
                  mb: 0.5,
                }}
              >
                Welcome to SimplerHome.
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  color: "#ffffff",
                  fontWeight: 400,
                //   fontStyle: "italic",
                  fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" },
                  lineHeight: 1.4,
                  opacity: 0.95,
                }}
              >
                Let's make homeownership simpler, together.
              </Typography>
            </Box>
          </Box>

          {/* Right Image Section */}
          <Box
            sx={{
              flex: 1,
              minHeight: { xs: 300, sm: 400, md: "auto" },
              position: "relative",
            }}
          >
            <Box
              component="img"
              src={teamImage}
              alt="Man looking at his home"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: { md: "absolute" },
                top: 0,
                left: 0,
              }}
            />
          </Box>
        </Box>
      </FullPaddingWrapper>
    </Container>
  );
});

export default MessageFromTeam;
